const useStyles = () => {
    return {
        commentInfo: {
            display: 'flex',
            flexDirection: 'column',
            flex: '1 0 200px'
        },
        comment: {
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            alignItems: 'start',
            gap: 2
        },
    }
}

export { useStyles }